import type { DioramaState } from './dioramaState';
import { dioramaConfigs } from './DioramaConfig';

function isNextDioramaAvailable(currentIndex: number): boolean {
  return !!dioramaConfigs[currentIndex + 1];
}

// in case user finished all dioramas and we added new ones
export function tryTransitionToNextDiorama(state: DioramaState): DioramaState {
  const { tilesAmount, dioramaIndex } = state;
  if (tilesAmount < getDioramaMaxTilesAmount(dioramaIndex)) return state;
  if (!isNextDioramaAvailable(dioramaIndex)) return state;

  state.dioramaIndex += 1;
  state.tilesAmount = 0;
  return state;
}

export function getDioramaMaxTilesAmount(dioramaIndex: number): number {
  return dioramaConfigs[dioramaIndex].pieces.reduce((acc, { price }) => acc + price, 0);
}

export function increaseDioramaProgress(state: DioramaState, tilesIncrease: number): DioramaState {
  const maxTiles = getDioramaMaxTilesAmount(state.dioramaIndex);
  state.tilesAmount = Math.min(state.tilesAmount + tilesIncrease, maxTiles);
  return tryTransitionToNextDiorama(state);
}

export function getDioramaMissingTilesAmount(state: DioramaState): number {
  return getDioramaMaxTilesAmount(state.dioramaIndex) - state.tilesAmount;
}

export function isDioramaAtEndOfContent(state: DioramaState): boolean {
  const maxIndex = dioramaConfigs.length - 1;
  if (state.dioramaIndex < maxIndex) return false;
  return state.tilesAmount >= getDioramaMaxTilesAmount(state.dioramaIndex);
}

export function getDioramaNumberOfPieces(dioramaIndex: number): number {
  return dioramaConfigs[dioramaIndex].pieces.length;
}

export function getDioramaCompletedPieces(state: DioramaState): number {
  let progress = state.tilesAmount;

  return dioramaConfigs[state.dioramaIndex].pieces
    .filter((piece) => {
      progress -= piece.price;
      return progress >= 0;  
    }).length;
}

export function debugCreateFullyUnlockedState(): DioramaState {
  return {
    dioramaIndex: dioramaConfigs.length - 1,
    tilesAmount: 99999999,
  };
}

export function debugCreateAlmostUnlockedState(): DioramaState {
  const dioramaIndex = 0;

  return {
    dioramaIndex,
    tilesAmount: getDioramaMaxTilesAmount(dioramaIndex) - 10,
  };
}